import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { AppFlowService } from "../services/app-flow/app-flow.service";

@Injectable({
  providedIn: "root",
})
export class LandingPageRouteGuard  {
  constructor(private router: Router, private appFlowService: AppFlowService) {}

  // eslint-disable-next-line unused-imports/no-unused-vars-ts
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const appFlow = this.appFlowService.getActiveAppFlow();
    const landingPage = appFlow.start;
    const parent = next.parent.routeConfig.path;
    return this.router.parseUrl(`/${parent}/${landingPage}`);
  }
}
